import { render, staticRenderFns } from "./TokenSignUp.vue?vue&type=template&id=45494f5f&scoped=true&"
import script from "./TokenSignUp.vue?vue&type=script&lang=js&"
export * from "./TokenSignUp.vue?vue&type=script&lang=js&"
import style0 from "./TokenSignUp.vue?vue&type=style&index=0&id=45494f5f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45494f5f",
  null
  
)

export default component.exports